export function signalSidebar() {
  const article = document.querySelector('.signal-content-wrapper');
  const column = document.querySelector('.signal-sidebar');
  const sidebar = document.querySelector('.signal-sidebar__inner');
  const header = document.querySelector('.site-header');
  if (!article || !column || !sidebar || !header) return;

  let framePending = false;
  let previousOffset;
  function update() {
    framePending = false;
    // The header's bottom already includes the WordPress admin bar and any banner.
    const offset = Math.max(0, Math.ceil(header.getBoundingClientRect().bottom)) + 12;
    if (offset !== previousOffset) {
      article.style.setProperty('--article-header-offset', `${offset}px`);
      previousOffset = offset;
    }
    // Measure the column, whose position is unaffected by the sticky child.
    const padding = parseFloat(window.getComputedStyle(column).paddingTop) || 0;
    const naturalTop = column.getBoundingClientRect().top + padding;
    sidebar.classList.toggle('is-sticky', naturalTop <= offset);
  }

  function scheduleUpdate() {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(update);
  }
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('load', scheduleUpdate);
  if (window.ResizeObserver) {
    new window.ResizeObserver(scheduleUpdate).observe(header);
  }
  update();
}
